import { FC, useMemo } from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import getStyles from "./styles";

const Row: FC<{ label: string; value: string | number, legend?: string }> = ({ label, value, legend }) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).Row, [theme]);

  return (
    <Stack sx={styles.container}>
      <Typography>{label} {legend && <Box component="span" sx={styles.legend}>{legend}</Box>}</Typography>
      <Typography>{value}</Typography>
    </Stack>
  );
};

export default Row;
